export const LINE_LEGEND_PLUGIN = {
  beforeDraw: function (chart) {
    const datasets = chart.config.data.datasets
    chart.legend.legendItems.forEach((item) => {
      const dataset = datasets[item.datasetIndex]
      if (dataset.type === "line") item.fillStyle = "transparent"
    })
  },
}
